export default "__VITE_ASSET__f6fd65a6__"